<template>
  <div class="container">
    <p class="rank">
      <img :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon">
      {{ rankName }}RANK
    </p>
    <p v-if="maxValue != 1">Up to next rank</p>
    <div v-if="maxValue != 1" class="graph">
      <div class="bar" :style="{ width: barWidth + '%', backgroundColor: barColor }"></div>
    </div>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';
import { mapGetters } from 'vuex';

export default {
  name: 'BarGraph',
  props: {
    maxValue: {
      type: Number || String,
      default: 0,
    },
    currentValue: {
      type: Number || String,
      default: 0,
    },
    barColor: {
      type: String,
      default: '#000',
    },
    rankName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
    barWidth() {
      return (this.currentValue / this.maxValue) * 100 > 100 ? 100 : (this.currentValue / this.maxValue) * 100;
    },
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(parseInt(value, 10));
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  font-family: Arial, sans-serif;
}
.rank {
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  .rank_icon {
    width: 36px;
    margin-right: 10px;
  }
}
p {
  color: #FFF;
}
.graph {
  width: 300px;
  height: 30px;
  border: 1px solid #FFF;
  margin: 0 auto;
  position: relative;
  background-color: #FFF;
}
.bar {
  height: 100%;
  position: absolute;
  left: 0;
}
</style>
